export default function () {
    return {
        product: null,
        productAnalogs: null,
        productFormFactor: null,
        productAdditionalSales: null,
        currentProductAnalogs: null,
    };
}
